// extracted by mini-css-extract-plugin
export default {"icon":"ArrowLeftIcon_icon__bUjyR"};